import React, { Component } from "react"
import { Modal, Select, Row, Col } from "antd"

import 'asset/style/dashboard.css'
import 'asset/style/add_case.css'
import 'asset/style/theme/theme.scoped.scss'
import { error_manager } from "helper/error_manager"

class ConfirmPolicyChange extends Component {
    constructor(props) {
        super(props)

        this.state = {
            policy: null,
            usernames: this.props.usernames
        }
    }

    componentDidUpdate() {
        if (this.state.usernames.length < 1) {
           this.props.closeModal()
        }
    }

    renderUsernames = () => {
        return (
            <ul>
                {this.state.usernames.map(e =>
                    <li>
                        <b>{e}</b>
                    </li>
                )}
            </ul>
        )
    }

    setPolicyUsers = () => {
        if (!this.state.policy) {
            error_manager("Please select are policy.", null)
            return
        }

        this.props.setPolicyUsers({
            policy: this.state.policy,
            usernames: this.state.usernames
        })

        this.props.closeModal()
    }
    
    render() {
        return (
            <Modal
                onOk={() => this.setPolicyUsers()}
                onCancel={() => this.props.closeModal()}
                title={"Confirm Policy"}
                visible={this.props.showModal}
            >
                <div>
                    <Row>
                        <div>
                            {"Selected Users"}
                            {this.renderUsernames()}
                        </div>
                    </Row>
                    <Row>
                        <div>{"Please select access policy for above user(s)?"}</div>
                    </Row>
                    <Row className="add-case-row-popup">
                        <Col span={5} className="add-case-row-header">
                            <b>Policy</b>
                        </Col>
                        <Col span={8}>
                            <Select
                                defaultValue={this.props.allPolicies?.[0]}
                                autoComplete="off"
                                className="input-field-add-case"
                                style={{ color: 'black' }}
                                onChange={(policy) => this.setState({ policy })}
                                value={this.state.policy}
                            >
                                {this.props.allPolicies?.map(e => <Select.Option value={e}>{e}</Select.Option>)}
                            </Select>
                        </Col>
                    </Row>
                    
                </div>
            </Modal>
        )
    }
}

export default ConfirmPolicyChange